// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daily-words {
  width: 100%;
  max-width: 900px;
  box-sizing: border-box;
  margin: 16px 0 24px;
  padding: 22px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: linear-gradient(135deg, #eef2ff 0%, #faf5ff 100%);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.08);
}

.daily-words.is-collapsed {
  padding-bottom: 16px;
}

.dw-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.dw-header h3 {
  margin: 0;
  font-size: 18px;
  color: #4338ca;
  white-space: nowrap;
}

.dw-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.dw-title-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.dw-bookmarks-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #c7d2fe;
  border-radius: 7px;
  padding: 5px 8px;
  background: #fff;
  color: #4338ca;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.dw-bookmarks-link:hover {
  background: #eef2ff;
}

.dw-expand {
  margin-left: auto;
  border: 1px solid #c7d2fe;
  border-radius: 8px;
  padding: 6px 10px;
  background: #fff;
  color: #4338ca;
  font-size: 13px;
  cursor: pointer;
}

.dw-expand:hover {
  background: #eef2ff;
}

.dw-refresh {
  border: none;
  background: #6366f1;
  color: #fff;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  margin-left: auto;
  white-space: nowrap;
  transition: background 0.2s, transform 0.1s;
}

.dw-refresh:hover:not(:disabled) {
  background: #4f46e5;
}

.dw-refresh:active:not(:disabled) {
  transform: scale(0.97);
}

.dw-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dw-card {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
}

.dw-word-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.dw-word {
  font-size: 26px;
  font-weight: 700;
  color: #1e1b4b;
  text-transform: capitalize;
}

.dw-pos {
  font-size: 13px;
  font-style: italic;
  color: #8b5cf6;
  background: #f3e8ff;
  padding: 2px 8px;
  border-radius: 6px;
}

.dw-bookmark-btn,
.word-search-bookmark {
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  padding: 4px 8px;
  background: #fff;
  color: #6366f1;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.dw-bookmark-btn:hover,
.word-search-bookmark:hover {
  background: #eef2ff;
}

.dw-meaning-row,
.dw-example-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dw-meaning {
  color: #334155;
  margin: 6px 0;
  line-height: 1.5;
  flex: 1;
}

.dw-example {
  color: #64748b;
  font-style: italic;
  border-left: 3px solid #c7d2fe;
  padding-left: 10px;
  margin: 10px 0;
  flex: 1;
}

.dw-voice-btn {
  border: 1px solid #dbeafe;
  background: #f8fafc;
  color: #4338ca;
  width: 26px;
  height: 26px;
  min-width: 26px;
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding: 0;
  transition: background 0.15s, transform 0.08s;
}

.dw-voice-btn:hover {
  background: #eef2ff;
}

.dw-voice-btn:active {
  transform: scale(0.96);
}

.dw-voice-btn.small {
  width: 22px;
  height: 22px;
  min-width: 22px;
  font-size: 11px;
}

.dw-synonyms {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
}

.dw-syn-label {
  font-size: 13px;
  color: #64748b;
  margin-right: 2px;
}

.dw-syn-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  background: #e0e7ff;
  color: #4338ca;
  padding: 3px 9px;
  border-radius: 12px;
}

.dw-mini-voice {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dw-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #6366f1;
  padding: 8px 0;
}

.dw-spinner {
  width: 18px;
  height: 18px;
  border: 3px solid #c7d2fe;
  border-top-color: #6366f1;
  border-radius: 50%;
  animation: dw-spin 0.8s linear infinite;
}

@keyframes dw-spin {
  to { transform: rotate(360deg); }
}

.dw-error {
  color: #ef4444;
  font-size: 14px;
  padding: 6px 0;
}

/* Tabs for language selection */
.dw-tabs {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  margin-left: 0;
  overflow: visible;
  flex-wrap: nowrap;
}

.dw-tab {
  flex: 1 1 0;
  min-width: 0;
  border: 1px solid transparent;
  background: transparent;
  color: #374151;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, transform 0.06s;
}

.dw-tab:hover:not(:disabled) {
  background: #f3f4f6;
}

.dw-tab:active:not(:disabled) {
  transform: translateY(1px);
}

.dw-tab.active {
  background: #eef2ff;
  color: #4338ca;
  border-color: #e0e7ff;
}

/* Transliteration / small note */
.dw-translit {
  color: #6b7280;
  font-size: 13px;
  margin: 4px 0;
  font-style: italic;
}

.dw-example-translit {
  color: #9ca3af;
  font-size: 12px;
  margin: 2px 0 8px;
}
`, "",{"version":3,"sources":["webpack://./src/features/DailyWords/dailyWords.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".daily-words {\n  width: 100%;\n  max-width: 900px;\n  box-sizing: border-box;\n  margin: 16px 0 24px;\n  padding: 22px 24px;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #eef2ff 0%, #faf5ff 100%);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.08);\n}\n\n.daily-words.is-collapsed {\n  padding-bottom: 16px;\n}\n\n.dw-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.dw-header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #4338ca;\n  white-space: nowrap;\n}\n\n.dw-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n}\n\n.dw-title-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n}\n\n.dw-bookmarks-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid #c7d2fe;\n  border-radius: 7px;\n  padding: 5px 8px;\n  background: #fff;\n  color: #4338ca;\n  font-size: 12px;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.dw-bookmarks-link:hover {\n  background: #eef2ff;\n}\n\n.dw-expand {\n  margin-left: auto;\n  border: 1px solid #c7d2fe;\n  border-radius: 8px;\n  padding: 6px 10px;\n  background: #fff;\n  color: #4338ca;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.dw-expand:hover {\n  background: #eef2ff;\n}\n\n.dw-refresh {\n  border: none;\n  background: #6366f1;\n  color: #fff;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  cursor: pointer;\n  margin-left: auto;\n  white-space: nowrap;\n  transition: background 0.2s, transform 0.1s;\n}\n\n.dw-refresh:hover:not(:disabled) {\n  background: #4f46e5;\n}\n\n.dw-refresh:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.dw-refresh:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.dw-card {\n  background: #fff;\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.dw-word-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.dw-word {\n  font-size: 26px;\n  font-weight: 700;\n  color: #1e1b4b;\n  text-transform: capitalize;\n}\n\n.dw-pos {\n  font-size: 13px;\n  font-style: italic;\n  color: #8b5cf6;\n  background: #f3e8ff;\n  padding: 2px 8px;\n  border-radius: 6px;\n}\n\n.dw-bookmark-btn,\n.word-search-bookmark {\n  border: 1px solid #c7d2fe;\n  border-radius: 999px;\n  padding: 4px 8px;\n  background: #fff;\n  color: #6366f1;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.dw-bookmark-btn:hover,\n.word-search-bookmark:hover {\n  background: #eef2ff;\n}\n\n.dw-meaning-row,\n.dw-example-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dw-meaning {\n  color: #334155;\n  margin: 6px 0;\n  line-height: 1.5;\n  flex: 1;\n}\n\n.dw-example {\n  color: #64748b;\n  font-style: italic;\n  border-left: 3px solid #c7d2fe;\n  padding-left: 10px;\n  margin: 10px 0;\n  flex: 1;\n}\n\n.dw-voice-btn {\n  border: 1px solid #dbeafe;\n  background: #f8fafc;\n  color: #4338ca;\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  border-radius: 999px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  padding: 0;\n  transition: background 0.15s, transform 0.08s;\n}\n\n.dw-voice-btn:hover {\n  background: #eef2ff;\n}\n\n.dw-voice-btn:active {\n  transform: scale(0.96);\n}\n\n.dw-voice-btn.small {\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  font-size: 11px;\n}\n\n.dw-synonyms {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.dw-syn-label {\n  font-size: 13px;\n  color: #64748b;\n  margin-right: 2px;\n}\n\n.dw-syn-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  background: #e0e7ff;\n  color: #4338ca;\n  padding: 3px 9px;\n  border-radius: 12px;\n}\n\n.dw-mini-voice {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n  font-size: 10px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dw-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #6366f1;\n  padding: 8px 0;\n}\n\n.dw-spinner {\n  width: 18px;\n  height: 18px;\n  border: 3px solid #c7d2fe;\n  border-top-color: #6366f1;\n  border-radius: 50%;\n  animation: dw-spin 0.8s linear infinite;\n}\n\n@keyframes dw-spin {\n  to { transform: rotate(360deg); }\n}\n\n.dw-error {\n  color: #ef4444;\n  font-size: 14px;\n  padding: 6px 0;\n}\n\n/* Tabs for language selection */\n.dw-tabs {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  width: 100%;\n  margin-left: 0;\n  overflow: visible;\n  flex-wrap: nowrap;\n}\n\n.dw-tab {\n  flex: 1 1 0;\n  min-width: 0;\n  border: 1px solid transparent;\n  background: transparent;\n  color: #374151;\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, transform 0.06s;\n}\n\n.dw-tab:hover:not(:disabled) {\n  background: #f3f4f6;\n}\n\n.dw-tab:active:not(:disabled) {\n  transform: translateY(1px);\n}\n\n.dw-tab.active {\n  background: #eef2ff;\n  color: #4338ca;\n  border-color: #e0e7ff;\n}\n\n/* Transliteration / small note */\n.dw-translit {\n  color: #6b7280;\n  font-size: 13px;\n  margin: 4px 0;\n  font-style: italic;\n}\n\n.dw-example-translit {\n  color: #9ca3af;\n  font-size: 12px;\n  margin: 2px 0 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
